import {RxGroupProperty} from '../../../../../../../../common/model/db/types/RxGroupProperty';
import {workflowPropertyNameRegex} from './workflowPropertyNameRegex';
import {isDefined} from '../../../../../../../../common/types/guards/isDefined';

export function isWorkflowProperty(groupProperty: RxGroupProperty): boolean {
    return isDefined(groupProperty.property_ref?.name?.match?.(workflowPropertyNameRegex));
}
